export default __webpack_public_path__ + "static/media/neraca.49004fe9.png";